import React from 'react';
import PropTypes from 'prop-types';
import Pagination from 'react-js-pagination';
import './styles.css';

const PagePagination = props => {
  const {
    page,
    perPage,
    count,
    pageRangeDisplayed,
    hideFirstLastPages = true,
    hideNavigation = false,
    controlFunc,
    minimalStyle = false,
    scrollToTop = true,
  } = props;
  const activePage = page + 1;

  const changePageHandler = pageNumber => {
    if (scrollToTop) {
      window.scrollTo(
        0,
        document.getElementsByClassName('app__content')[0].offsetTop
      );
    }
    controlFunc(pageNumber - 1);
  };

  return (
    <div
      className={
        !minimalStyle
          ? 'page-pagination__wrapper'
          : 'page-pagination__wrapper page-pagination__wrapper--minimal'
      }
    >
      <Pagination
        innerClass={
          !minimalStyle
            ? 'page-pagination'
            : 'page-pagination page-pagination--minimal'
        }
        itemClass="page-pagination__item"
        activeClass="page-pagination__item--active"
        disabledClass="page-pagination__item--disabled"
        linkClass="page-pagination__item-link"
        activeLinkClass="page-pagination__item-link--active"
        itemClassPrev="page-pagination__item--prev"
        itemClassNext="page-pagination__item--next"
        itemClassFirst="page-pagination__item--prev"
        itemClassLast="page-pagination__item--next"
        prevPageText={
          <span className="page-pagination__icon page-pagination__icon--left" />
        }
        nextPageText={
          <span className="page-pagination__icon page-pagination__icon--right" />
        }
        firstPageText={
          <span className="page-pagination__icon page-pagination__icon--first" />
        }
        lastPageText={
          <span className="page-pagination__icon page-pagination__icon--last" />
        }
        activePage={activePage}
        itemsCountPerPage={perPage}
        totalItemsCount={count}
        pageRangeDisplayed={pageRangeDisplayed}
        onChange={changePageHandler}
        hideFirstLastPages={hideFirstLastPages}
        hideNavigation={hideNavigation}
      />
    </div>
  );
};

PagePagination.propTypes = {
  page: PropTypes.number.isRequired,
  perPage: PropTypes.number.isRequired,
  count: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  pageRangeDisplayed: PropTypes.number.isRequired,
  controlFunc: PropTypes.func.isRequired,
  hideFirstLastPages: PropTypes.bool,
  hideNavigation: PropTypes.bool,
  minimalStyle: PropTypes.bool,
  scrollToTop: PropTypes.bool,
};

export default PagePagination;
